// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"WorkflowTriggerSelector_dropdownContainer__3JoHC","buttonContainer":"WorkflowTriggerSelector_buttonContainer__2xVTZ"};